import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import { usePermissions } from '@/providers/Permissions.provider';

/**
 * Whether creating an account will actually send the onboarding application form to the primary
 * contact. The backend forces the email off for Technology partners and for VARs carrying
 * reporting liability, and refuses it without onboarding-form access — so copy promising the email
 * (the contact-email tooltip, the review note) only shows when it will really send.
 */
export default function useWillSendOnboardingEmail(): boolean {
  const { permissions } = usePermissions();

  const {
    response: { partnerType },
  } = usePartnerLogin();

  return (
    permissions.accountOnboardingFormAccess &&
    partnerType !== 'Technology' &&
    !(partnerType === 'VAR' && permissions.partnerLiability)
  );
}
